export class CardDefinition {
  id?: string;
  channel_id?: string;
  card_prefix?: string;
  card_suffix?: string;
  cluster_id?: string;
  card_lenght?: number;
  range_min?: string;
  range_max?: string;
  barcode_type_pid?: number;
  card_loyalty_type_pid?: number;
  description: string;
  balance_type_gen?: string;
  balance_type_req?: string;
  mask?: string;
  flg_std_promo_cnf?: number;
  flg_point_acc?: number;
  flg_points_fru?: number;

  channelDescription?: string;
  channelCode?: string;
  clusterDescription?: string;
  clusterType?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-card-definition.model.ts